var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720.62 400.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#353cb0;}.cls-2{fill:#2f398f;}.cls-3{fill:#ffd2b9;}.cls-4{fill:#f2bda8;}.cls-5{fill:none;stroke:#010101;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.5px;}.cls-6{fill:#3e3e42;}.cls-7{fill:#6b6d71;}.cls-12,.cls-8{fill:#fff;}.cls-9{fill:#d5d9dd;}.cls-10{fill:#aaaeb2;}.cls-11{fill:#ff563c;}.cls-12{font-size:16.71px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "problen to send") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.13,
    width: 720,
    height: 400
  })), /*#__PURE__*/React.createElement("g", {
    id: "bg-elements"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.44,202.45q-38,0-63.55,25.8t-25.46,61.89q0,36.62,25.8,62.25,25.61,25.8,62.39,25.79,36.28,0,61.92-25.47,25.79-25.79,25.79-62.73,0-36.27-25.64-61.9t-61.23-25.63m34.61,123.47q-14.47,14.49-35.45,14.49a48,48,0,0,1-35.28-14.49q-14.81-14.64-14.8-35.94a49.69,49.69,0,0,1,49.75-49.76q21.65,0,36.11,14.64a48.39,48.39,0,0,1,14.47,35.28q0,21.15-14.79,35.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.31,0q6.3,125,93.25,211.33,90.85,89.78,217,92.34a0,0,0,0,0,0,0V165c-46.79-1.66-87-18.95-120.31-52.25Q552.72,65.17,547.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.28,207.06,59.17,192q-6.18-6,0-11.91l59.17-59.17q6-6.18,11.91,0L145.35,136q6.18,5.94,0,11.9L86.17,207.06q-5.94,6.18-11.89,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "object"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1776",
    "data-name": "Trazado 1776",
    className: "cls-3",
    d: "M390.09,400.13,271.64,288.39,242,258.72S207.91,230.15,231.76,225c0,0-19.38-29.53,10.2-22.44,0,0-13.83-11.89-6.12-18.93,9.08-5.28,25.2,1.51,29.6,9.24,9.44,16.57,22.69-37.39,22.69-37.39l75.58,63,1.38-4.32a21.22,21.22,0,0,1,1.85-3.69c-21.19-15.31-27.56-30-28.91-40.32a7.76,7.76,0,0,1,12.07-7.45c17.44,11.92,51.15,35.72,60.79,47.77,13.19,16.48,15.39,76.91,15.39,76.91L570.86,400.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1777",
    "data-name": "Trazado 1777",
    className: "cls-4",
    d: "M390.09,400.13,271.64,288.39,242,258.72S207.91,230.15,231.76,225c0,0-21.37-33.2,16.62-20.61L504.25,400.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1778",
    "data-name": "Trazado 1778",
    className: "cls-5",
    d: "M365.09,214.15c-2.89,7.16-6.39,24,11.74,44.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1779",
    "data-name": "Trazado 1779",
    className: "cls-5",
    d: "M231.54,224.11l33,23.07,14.29,13.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1780",
    "data-name": "Trazado 1780",
    className: "cls-5",
    d: "M342.22,251.66s3.29,29.67-13.19,44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1781",
    "data-name": "Trazado 1781",
    className: "cls-3",
    d: "M426.28,287.37s-2.2-60.43-15.39-76.91c-9.64-12.05-43.35-35.85-60.79-47.77A7.76,7.76,0,0,0,338,170.15c1.34,10.32,7.71,25,28.9,40.31a21.94,21.94,0,0,0-1.85,3.69l-1.38,4.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 248.2,
    y: 43.43,
    width: 113.4,
    height: 238.03,
    rx: 8.37,
    transform: "translate(-0.22 0.42) rotate(-0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 251.78,
    y: 47.04,
    width: 105.96,
    height: 231.46,
    rx: 7.98,
    transform: "matrix(1, 0, 0, 1, -0.22, 0.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 251.78,
    y: 58.11,
    width: 105.96,
    height: 210.32,
    rx: 7.6,
    transform: "translate(-0.22 0.42) rotate(-0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 295.28,
    y: 51.93,
    width: 18.66,
    height: 2.35,
    rx: 1.18,
    transform: "translate(-0.07 0.42) rotate(-0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 320.32,
    y: 51.9,
    width: 2.35,
    height: 2.35,
    rx: 1.18,
    transform: "translate(-0.07 0.44) rotate(-0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 326.25,
    y: 51.89,
    width: 2.35,
    height: 2.35,
    rx: 1.18,
    transform: "translate(-0.07 0.45) rotate(-0.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 304.58,
    cy: 155.64,
    r: 41.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M305.85,131.36a24.75,24.75,0,1,0,24.75,24.75A24.77,24.77,0,0,0,305.85,131.36Zm-22.57,25.81h8.17a40.69,40.69,0,0,0,1.32,9.48h-6.92A22.49,22.49,0,0,1,283.28,157.17Zm23.63-13.72v-9.87c3.8.6,7.1,4.37,9.13,9.87Zm9.82,2.12a38.19,38.19,0,0,1,1.39,9.48H306.91v-9.48Zm-11.94-12v9.87h-9.12C297.69,138,301,134.18,304.79,133.58Zm0,12v9.48h-11.2a37.73,37.73,0,0,1,1.39-9.48Zm-13.34,9.48h-8.17a22.45,22.45,0,0,1,2.57-9.48h6.92A40.54,40.54,0,0,0,291.45,155.05Zm2.14,2.12h11.2v9.48H295A37.8,37.8,0,0,1,293.59,157.17Zm11.2,11.6v9.87c-3.79-.6-7.1-4.37-9.12-9.87Zm2.12,9.87v-9.87H316C314,174.27,310.71,178,306.91,178.64Zm0-12v-9.48h11.21a38.26,38.26,0,0,1-1.39,9.48Zm13.34-9.48h8.18a22.49,22.49,0,0,1-2.57,9.48h-6.92A40.7,40.7,0,0,0,320.25,157.17Zm0-2.12a40.55,40.55,0,0,0-1.31-9.48h6.92a22.45,22.45,0,0,1,2.57,9.48Zm4.35-11.6h-6.3a22.72,22.72,0,0,0-5.08-8.72A22.74,22.74,0,0,1,324.6,143.45Zm-26.11-8.72a22.72,22.72,0,0,0-5.08,8.72h-6.3A22.74,22.74,0,0,1,298.49,134.73Zm-11.38,34h6.3a22.68,22.68,0,0,0,5.08,8.71A22.67,22.67,0,0,1,287.11,168.77Zm26.11,8.71a22.68,22.68,0,0,0,5.08-8.71h6.3A22.67,22.67,0,0,1,313.22,177.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 326.93,
    cy: 123.97,
    r: 10.16
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(324.81 130.18)"
  }, "!"), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1792",
    "data-name": "Trazado 1792",
    className: "cls-3",
    d: "M426.28,287.37s-2.2-60.43-15.39-76.91c-9.64-12.05-43.35-35.85-60.79-47.77A7.76,7.76,0,0,0,338,170.15c1.34,10.32,7.71,25,28.9,40.31a21.94,21.94,0,0,0-1.85,3.69l-1.38,4.32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorConnect);
export default __webpack_public_path__ + "static/media/error-connect.6ede6a45b094ca62a60c83b3daefbcb0.svg";
export { ForwardRef as ReactComponent };